import { IAvailableDaysDataHandler } from '../../data-handlers/available-days/IAvailableDaysDataHandler'
import { AvailableDays } from '../../entities/available-days/AvailableDays'

export class AvailableDaysRepository {
  handler: IAvailableDaysDataHandler

  constructor(handler: IAvailableDaysDataHandler) {
    this.handler = handler
  }

  get(): Promise<AvailableDays> {
    return this.handler.get()
  }
}
